import { Link } from "@tanstack/react-router";
import { Home, BookOpen, Library, Calendar, Search } from "lucide-react";
import { useState } from "react";
import { BrandedErrorLayout } from "./BrandedErrorLayout";

const DESTINATIONS = [
  { label: "Home", href: "/", icon: Home },
  { label: "The Academy", href: "/academy", icon: BookOpen },
  { label: "The Currency Thoughts Store", href: "/store", icon: Library },
  { label: "Book a Consultation", href: "/book", icon: Calendar },
] as const;

export function NotFoundPage() {
  const [q, setQ] = useState("");

  return (
    <BrandedErrorLayout
      eyebrow="Page Not Found"
      sealTitle="404"
      heading={
        <>
          This page seems to have{" "}
          <em className="italic text-bronze-600">wandered off.</em>
        </>
      }
      body="The page you're looking for may have moved, or the link you followed may be incorrect. Let us help you find your way back."
    >
      <form
        action="/academy"
        method="get"
        className="mx-auto flex w-full max-w-md items-center gap-2 rounded-full border border-bronze-600/30 bg-white p-1 shadow-sm focus-within:border-bronze-600"
      >
        <Search className="ml-3 h-4 w-4 shrink-0 text-charcoal-500" aria-hidden />
        <input
          name="q"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search the site…"
          className="min-w-0 flex-1 bg-transparent px-1 py-2 font-sans text-sm text-charcoal-900 placeholder:text-charcoal-500 focus:outline-none"
          aria-label="Search"
        />
        <button
          type="submit"
          className="rounded-full bg-bronze-600 px-4 py-2 font-sans text-xs font-semibold uppercase tracking-[0.05em] text-navy-900 transition-colors hover:bg-bronze-400"
        >
          Search
        </button>
      </form>

      <div className="mt-8">
        <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-charcoal-500">
          Popular Destinations
        </p>
        <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-4">
          {DESTINATIONS.map(({ label, href, icon: Icon }) => (
            <Link
              key={href}
              to={href}
              className="group flex flex-col items-center gap-2 rounded-md bg-cream-50 p-4 transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_24px_-12px_rgba(168,139,92,0.4)]"
            >
              <Icon className="h-5 w-5 text-bronze-600 transition-transform group-hover:scale-110" />
              <span className="font-sans text-[12px] font-medium text-navy-800">{label}</span>
            </Link>
          ))}
        </div>
      </div>
    </BrandedErrorLayout>
  );
}

export default NotFoundPage;